module.exports = __webpack_public_path__ + "img/symbol_4.2d6a9f67.png";